<button mat-raised-button class="no-print" (click)="handleWhichFunctionToUse()" *ngIf="(device.isWebview$ | async) === false">
	<mat-icon color="primary">print</mat-icon>
	<ng-container *ngIf="!hideText">הצג גרסה להדפסה</ng-container>
</button>
